// Adapted from React Bits Spotlight Card: https://reactbits.dev/components/spotlight-card
// License and attribution: ../../THIRD_PARTY_NOTICES.md
const SpotlightSurface = ({ children, className = '', ...props }) => {
  const handlePointerMove = (event) => {
    if (event.pointerType !== 'mouse') return;

    const bounds = event.currentTarget.getBoundingClientRect();
    event.currentTarget.style.setProperty('--spotlight-x', `${event.clientX - bounds.left}px`);
    event.currentTarget.style.setProperty('--spotlight-y', `${event.clientY - bounds.top}px`);
    if (!event.currentTarget.hasAttribute('data-spotlight-active')) {
      event.currentTarget.setAttribute('data-spotlight-active', '');
    }
  };

  const handlePointerLeave = (event) => {
    event.currentTarget.removeAttribute('data-spotlight-active');
  };

  return (
    <div className={`spotlight-surface ${className}`} onPointerMove={handlePointerMove} onPointerLeave={handlePointerLeave} {...props}>
      {children}
    </div>
  );
};

export default SpotlightSurface;
